export enum BaloiseWtcReasonBusinessRule {
    DateOfBirth = "DateOfBirth",
    CarValue = "CarValue",
    DriverTooYoung = "DriverTooYoung",
    DriverTooOld = "DriverTooOld",
    NumberOfYearsWithLicense = "NumberOfYearsWithLicense",
    YearsInsured = "YearsInsured",
    AccidentHistory = "AccidentHistory",
    RiskLevel = "RiskLevel",
    NumberOfRoomsTooLow = "NumberOfRoomsTooLow",
    NumberOfRoomsTooHigh = "NumberOfRoomsTooHigh",
    SimulationError = "SimulationError",
}

export enum BaloiseWtcReasonPage {
    SelectFamilySituation = "SelectFamilySituation",
    CarDescription = "CarDescription",
    DriverDetail = "DriverDetail",
    DriverHistory = "DriverHistory",
    PropertyDescription = "PropertyDescription",
    PropertyAddress = "PropertyAddress",
    PropertySpaces = "PropertySpaces",
}

export enum BaloiseWtcReasonReason {
    UserExit = "UserExit",
    BusinessRule = "BusinessRule",
}

export enum BaloisePostQuoteRequestLeadType {
    QuoteLead = "QuoteLead",
    ContactLead = "ContactLead",
    WtcMin = "WtcMin",
    ErrorFlow = "ErrorFlow",
}

export enum OccasionalDriverTitle {
    Mister = "Mister",
    Madam = "Madam",
}

export enum PaymentMethodFrequency {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Biannually = "Biannually",
    Yearly = "Yearly",
}

export enum PaymentMethodType {
    DirectDebit = "DirectDebit",
    Transfer = "Transfer",
}

export enum PolicyHolderTitle {
    Mister = "Mister",
    Madam = "Madam",
}

export enum UsualDriverTitle {
    Mister = "Mister",
    Madam = "Madam",
}

export enum QuoteVehicleInfoLicensePlateRegistrationType {
    Normal = "Normal",
    Personalized = "Personalized",
}

export enum FordGetQuoteTariffsRequestContextCategory {
    CarInsurance = "CarInsurance",
    CarInsuranceNewCar = "CarInsuranceNewCar",
    CarInsuranceSecondHandCar = "CarInsuranceSecondHandCar",
}

export enum PolicyHolderLanguage {
    ENG = "ENG",
    FRA = "FRA",
    NLD = "NLD",
}

export enum UsualDriverLanguage {
    ENG = "ENG",
    FRA = "FRA",
    NLD = "NLD",
}

export enum QuoteVehicleInfoFuelType {
    Gasoline = "Gasoline",
    MixedLubrication = "MixedLubrication",
    DieselAndLPG = "DieselAndLPG",
    HybridElectricityLPG = "HybridElectricityLPG",
    BioEthanol = "BioEthanol",
    HybridElectricityHydrogen = "HybridElectricityHydrogen",
    NaturalGasAndGasoline = "NaturalGasAndGasoline",
    Diesel = "Diesel",
    LPG = "LPG",
    Electricity = "Electricity",
    Other = "Other",
    NaturalGas = "NaturalGas",
    HybridElectricityGasoline = "HybridElectricityGasoline",
    HybridElectricityDiesel = "HybridElectricityDiesel",
    Hydrogen = "Hydrogen",
}

export enum QuoteVehicleInfoVehicleType {
    PersonalCar = "PersonalCar",
    LightTruck = "LightTruck",
}

export enum FordPostQuoteRequestContextCategory {
    CarInsurance = "CarInsurance",
    CarInsuranceNewCar = "CarInsuranceNewCar",
    CarInsuranceSecondHandCar = "CarInsuranceSecondHandCar",
}

export enum DiscountType {
    ThirdPartyLiability = "ThirdPartyLiability",
    Omnium = "Omnium",
}

export enum DeductibleType {
    Absolute = "Absolute",
    Percentage = "Percentage",
    English = "English",
}

export enum InsurancePackageFormula {
    Formula36 = "Formula36",
    Formula12 = "Formula12",
    Formula0 = "Formula0",
}

export enum OptionalGuaranteeType {
    DriverSafe = "DriverSafe",
    LegalAssistance = "LegalAssistance",
    SafetyPackOmnium = "SafetyPackOmnium",
}

export enum InsurancePackageType {
    ThirdPartyLiability = "ThirdPartyLiability",
    MiniOmnium = "MiniOmnium",
    FullOmnium = "FullOmnium",
}

export enum WtcReason {
    DriverTooOld = "DriverTooOld",
    DriverTooYoung = "DriverTooYoung",
    NumberOfYearsWithLicense = "NumberOfYearsWithLicense",
    YearsInsured = "YearsInsured",
    AccidentHistory = "AccidentHistory",
    UserExit = "UserExit",
    DateOfBirth = "DateOfBirth",
    CarValueTooLow = "CarValueTooLow",
    CarValueTooHigh = "CarValueTooHigh",
    CarTooOld = "CarTooOld",
    NoPriceAvailable = "NoPriceAvailable",
}

export enum QuoteTariffsDTOContextCategory {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum FordPostLeadRequestContextCategory {
    CarInsurance = "CarInsurance",
    CarInsuranceNewCar = "CarInsuranceNewCar",
    CarInsuranceSecondHandCar = "CarInsuranceSecondHandCar",
}

export declare enum SimulationVehicleInfoFuelType {
    Gasoline = "Gasoline",
    MixedLubrication = "MixedLubrication",
    DieselAndLPG = "DieselAndLPG",
    HybridElectricityLPG = "HybridElectricityLPG",
    BioEthanol = "BioEthanol",
    HybridElectricityHydrogen = "HybridElectricityHydrogen",
    NaturalGasAndGasoline = "NaturalGasAndGasoline",
    Diesel = "Diesel",
    LPG = "LPG",
    Electricity = "Electricity",
    Other = "Other",
    NaturalGas = "NaturalGas",
    HybridElectricityGasoline = "HybridElectricityGasoline",
    HybridElectricityDiesel = "HybridElectricityDiesel",
    Hydrogen = "Hydrogen",
}

export enum FordGetSimulationTariffsRequestContextCategory {
    CarInsurance = "CarInsurance",
    CarInsuranceNewCar = "CarInsuranceNewCar",
    CarInsuranceSecondHandCar = "CarInsuranceSecondHandCar",
}
